import { TextField, Stack } from "@mui/material";
import MainAccordion from "../Accordion/MainAccordion";

const VisitScheduleAccordion = ({
  handleDaysChange,
  handleHoursChange,
  handleDaysChangeEnd,
  days,
  hours,
  endDays,
  handleHoursChangeEnd,
  endHours,
  number,
  baseline_name,
  isLocked = false,
}) => {
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const role = user_data?.role;
  const isDisabled = role === "Investigator" || role === "Inv_coordinator" || isLocked;

  const isBaselineOrScreening = number === 0 || number === -3;

  return (
    <MainAccordion
      title={
        isBaselineOrScreening
          ? "Visit Schedule"
          : `Visit Schedule (after ${baseline_name || "Baseline Visit"})`
      }
      isOpen={true}
      data={
        <Stack spacing={1} sx={{ pb: 2 }}>
          <Stack container gap={2} wrap="false" direction={"row"}>
            {!isBaselineOrScreening && (
              <>
                <TextField
                  id="start-days"
                  label="Start Days"
                  type="number"
                  size="small"
                  disabled={isDisabled}
                  value={days}
                  onChange={handleDaysChange}
                  sx={{
                    width: "175px",
                  }}
                />

                <TextField
                  id="start-hours"
                  label="Start Hours"
                  type="number"
                  size="small"
                  disabled={isDisabled}
                  value={hours}
                  onChange={handleHoursChange}
                  sx={{
                    width: "175px",
                  }}
                />
              </>
            )}

            <TextField
              id="end-days"
              label="End Days"
              type="number"
              size="small"
              fullWidth
              disabled={isDisabled}
              value={endDays}
              onChange={handleDaysChangeEnd}
              sx={{
                width: "175px",
              }}
            />

            <TextField
              id="end-hours"
              label="End Hours"
              type="number"
              fullWidth
              disabled={isDisabled}
              value={endHours}
              onChange={handleHoursChangeEnd}
              sx={{
                width: "175px",
              }}
              size="small"
            />
          </Stack>
        </Stack>
      }
    />
  );
};

export default VisitScheduleAccordion;
